import {Button, Col, Form, message, Modal, Radio, Row, Select, Space, Table, Tooltip} from "antd";
import {CheckOutlined, ClockCircleOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {EXISTING_USER_ACCOUNT_CREATE_OPTION, NOT_AVAILABLE, YYYY_MM_DD_HH_MM} from "../../util/Constants";
import {DropdownListDto} from "../../dto/DropdownListDto";
import accountService from "../../service/accountService";
import ErrorHandler from "../../util/ErrorHandler";
import TextArea from "antd/es/input/TextArea";
import {JointAccountWrapperDto} from "../../dto/JointAccountWrapperDto";
import {JointAccountAcceptOrRejectInputDto} from "../../dto/JointAccountAcceptOrRejectInputDto";
import modal from "antd/es/modal";
import dayjs from "dayjs";
import {joint_acc_requests_title_img} from "../../../AppImageConst";
import {getLoggedUserCinNumber} from "../../security/KeyclockConfig";
import customerService from "../../service/customerService";

enum RecordStatus {
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED"

}

const JointAccountRequestList = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRejectReasonModalOpen, setIsRejectReasonModalOpen] = useState(false);
    const [isSpinnerLoading, setSpinnerLoading] = useState(false);
    const [accountCreationOption, setAccountCreationOption] = useState(EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC);
    const [accountList, setAccountList] = useState<DropdownListDto[]>([]);
    const [jointAccountRequestList, setJointAccountRequestList] = useState<JointAccountWrapperDto[]>([]);
    const [selectedRow, setSelectedRow] = useState<JointAccountWrapperDto>();
    const [cinNumber, setCinNumber] = useState<string | null>();


    useEffect(() => {
        getLoggedUserCIN()
    }, [])

    const getLoggedUserCIN = () => {
        // setSpinnerLoading(true)
        let cinNumber = getLoggedUserCinNumber();
        if (undefined != cinNumber) {
            setCinNumber(cinNumber)
            loadPendingJointAccountRequests(cinNumber)
        } else {
            customerService.getCustomerCINByLoggedUser().then(res => {
                let cinNumber = res.data.results;
                setCinNumber(cinNumber)
                loadPendingJointAccountRequests(cinNumber)
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinnerLoading(false)
            })
        }
    }

    const columns = [
        {
            title: 'Request ID',
            dataIndex: 'key',
            render: (text: any, rec: any, index: number) => {
                return (<span>{index + 1}</span>)
            }
        },
        {
            title: 'CIN Number',
            dataIndex: 'cidNumber',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Primary Holder Name',
            dataIndex: 'name'
        },
        {
            title: 'Primary Holder NIC',
            dataIndex: 'nicNumber'
        },
        {
            title: 'Primary Holder Status',
            dataIndex: 'isExistingCustomer',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? "Existing" : "New"}</span>)
            }
        },
        {
            title: 'Joint Account Status',
            dataIndex: 'isNewAccount',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? "New" : "Existing"}</span>)
            }
        },
        {
            title: 'Request DateTime',
            dataIndex: 'createdDateTime',
            render: (text: any, rec: any, index: number) => {
                return (<span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Actions',
            align: 'center' as const,
            fixed: 'right' as const,
            render: (text: any, record: any) => (
                <Space>
                    <Tooltip placement="top" title='Accept'>
                        <Button className='btn-action-outline-common btn-action-transfer'
                                onClick={() => showAccountCreationOptionsModal(record)}
                                icon={<CheckOutlined/>}>Accept</Button>
                    </Tooltip>
                    <Tooltip placement="top" title='Reject'>
                        <Button className='btn-action-outline-common btn-action-re-schedule'
                                onClick={() => showRejectReasonModal(record)}
                                icon={<ClockCircleOutlined/>}>Reject</Button>
                    </Tooltip>
                </Space>

            )
        },
    ]


    const showAccountCreationOptionsModal = (record: JointAccountWrapperDto) => {
        setSelectedRow(record)
        if (record.isNewAccount) {

            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure you want to accept this joint account request?`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    setIsModalOpen(true)
                },
                onCancel() {
                }
            });
        } else {
            console.log(record)
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure?, Do you want to join ${record.name.concat('\'s')} existing account as a second applicant?`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    handleAcceptOrReject(null, RecordStatus.ACCEPTED, record)
                },
                onCancel() {
                }
            });
        }
    }

    const showRejectReasonModal = (record: JointAccountWrapperDto) => {

        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure you want to reject this joint account request?`,
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setSelectedRow(record)
                setIsRejectReasonModalOpen(true)
            },
            onCancel() {
            }
        });
    }
    const handleCancel = () => {
        setIsModalOpen(false)
        setAccountCreationOption(EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC)
    }
    const handleRejectReasonCancel = () => {
        setIsRejectReasonModalOpen(false)
    }

    const handleAcceptOrReject = (values: any, status: RecordStatus, record: JointAccountWrapperDto | undefined) => {
        if (record && cinNumber) {
            setSpinnerLoading(true)
            let acceptRejectDto = {} as JointAccountAcceptOrRejectInputDto;
            if (RecordStatus.ACCEPTED == status) {
                handleCancel()
                acceptRejectDto = {
                    reference: record.reference,
                    recordStatus: RecordStatus.ACCEPTED,
                    isNewAccount: EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC == accountCreationOption,
                    isExistingCustomer: record.isExistingCustomer,
                    cidNumber: cinNumber,
                    accountNumber: EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC == accountCreationOption ? null : (null != values) ? values.accountNumber : null
                }
            } else {
                handleRejectReasonCancel()
                acceptRejectDto = {
                    reference: record.reference,
                    recordStatus: RecordStatus.REJECTED,
                    isExistingCustomer: record.isExistingCustomer,
                    cidNumber: cinNumber,
                    rejectReason: values.rejectReason
                }

            }
            accountService.acceptOrRejectJointAccountRequest(acceptRejectDto).then(res => {
                if (res.data.results) {
                    message.success(`Joint account request ${status.toLowerCase()} successfully`)
                    loadPendingJointAccountRequests(cinNumber)
                    // setSpinnerLoading(false)
                    setAccountCreationOption(EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC)
                } else {
                    message.error(`Failed to ${status === RecordStatus.ACCEPTED ? 'accept' : 'reject'} joint account request`)
                    setSpinnerLoading(false)
                    setAccountCreationOption(EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinnerLoading(false)
                setAccountCreationOption(EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC)
            })
        }

    }

    const onChangeAccCreationOption = (e: Event) => {
        setAccountCreationOption(+(e.target as HTMLInputElement).value)
        if (+(e.target as HTMLInputElement).value === EXISTING_USER_ACCOUNT_CREATE_OPTION.ADD_FIRST_HOLDER_TO_EXISTING_ACC) {
            loadAccList();
        }
    }

    const loadAccList = () => {
        accountService.getAccountListByLoggedUsername().then(res => {
            setAccountList(res.data.results)
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const loadPendingJointAccountRequests = (cinNumber: string) => {
        if (null != cinNumber) {
            setSpinnerLoading(true)
            accountService.getPendingJointAccountRequests(cinNumber).then(res => {
                setJointAccountRequestList(res.data.results)
                setSpinnerLoading(false)

            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinnerLoading(false)
            })
        } else {
            console.error("Unable to find cin number.");
        }
    }

    return (
        <>
            {/*<Spin spinning={isSpinnerLoading} tip="Loading" size="large">*/}

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'
                        style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div className='header_icon header-icon-center'>
                            <img style={{width:24}} src={joint_acc_requests_title_img} alt=""/>
                        </div>
                        Joint Account Requests
                    </h2>
                </Col>
            </Row>
            <Row gutter={[16, 16]} className='margin_top_20'>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Table scroll={{x: 'max-content'}} dataSource={jointAccountRequestList} columns={columns}
                           loading={isSpinnerLoading}/>
                    <Modal title="Account Creation Option"
                           open={isModalOpen}
                           destroyOnClose={true}
                           maskClosable={false}
                           footer={null}
                           onCancel={handleCancel}
                           className={'dashboard-account-open-modal'}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form
                                    layout={"vertical"}
                                    initialValues={{remember: true}}
                                    onFinish={(e: any) => handleAcceptOrReject(e, RecordStatus.ACCEPTED, selectedRow)}
                                >
                                    <h4 style={{marginTop: 8}}>Which of the following option do you prefer?</h4>
                                    <Form.Item
                                        // label={<b>Which of the following option do you prefer?</b>}
                                        style={{marginTop: 10, marginBottom: 10}}
                                        name={"preferredOption"}
                                    >
                                        <Radio.Group
                                            className='radio_group_set'
                                            onChange={onChangeAccCreationOption}
                                            defaultValue={EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC}
                                        >
                                            <Space direction="vertical">
                                                <Radio radioSize={20} dotSize={16}
                                                       value={EXISTING_USER_ACCOUNT_CREATE_OPTION.START_NEW_JOINT_ACC}>
                                                    Start a new joint account</Radio>
                                                <Radio radioSize={20} dotSize={16}
                                                       value={EXISTING_USER_ACCOUNT_CREATE_OPTION.ADD_FIRST_HOLDER_TO_EXISTING_ACC}>
                                                    Add first holder to my existing account</Radio>
                                            </Space>

                                        </Radio.Group>
                                    </Form.Item>
                                    {
                                        accountCreationOption ===
                                        EXISTING_USER_ACCOUNT_CREATE_OPTION.ADD_FIRST_HOLDER_TO_EXISTING_ACC ?
                                            <Form.Item
                                                style={{marginTop: 10}}
                                                label="Select Account Number"
                                                name={"accountNumber"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select account number'
                                                    }]}
                                            >

                                                <Select placeholder="Select account number"
                                                        size={'large'}
                                                        options={accountList}/>

                                            </Form.Item> : ''
                                    }
                                    <Row className='modal-btn-row'>
                                        <Col span={24}>
                                            <Space style={{float: 'right'}}>
                                                <Button onClick={handleCancel}>
                                                    Cancel
                                                </Button>
                                                <Button htmlType="submit"
                                                        type="primary">
                                                    Submit
                                                </Button>
                                            </Space>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>

                    </Modal>
                    <Modal title="Reject Reason"
                           open={isRejectReasonModalOpen}
                           destroyOnClose={true}
                           maskClosable={false}
                           footer={null}
                           onCancel={handleRejectReasonCancel}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form
                                    layout={"vertical"}
                                    initialValues={{remember: true}}
                                    onFinish={(e: any) => handleAcceptOrReject(e, RecordStatus.REJECTED, selectedRow)}
                                >
                                    {/*<h4>which of the following option do you prefer</h4>*/}
                                    <Form.Item
                                        name={"rejectReason"}
                                        label={"Reject Reason"}
                                        rules={[{
                                            required: true,
                                            message: 'Please enter reject reason'
                                        }]}>
                                        <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                                  bordered={true}/>
                                    </Form.Item>
                                    <Form.Item>
                                        <Space style={{float: 'right'}}>
                                            <Button onClick={handleRejectReasonCancel}>
                                                Cancel
                                            </Button>
                                            <Button htmlType="submit"
                                                    type="primary">
                                                Submit
                                            </Button>
                                        </Space>
                                    </Form.Item>


                                </Form>
                            </Col>
                        </Row>

                    </Modal>

                </Col>
            </Row>
            {/*</Spin>*/}
        </>


    )
}
export default JointAccountRequestList